module.exports = __webpack_public_path__ + "img/cpany18.34341ce9.png";